import { Spin } from "antd"

export const SpinCentro = () => {
    return <div style={{textAlign: "center", marginTop: 50}}><Spin size="large"/></div>
}